import * as React from 'react';
import { SVGProps, useId } from 'react';

const BoltIcon = (props: SVGProps<SVGSVGElement>) => {
  // Unique per instance: this icon renders multiple times per page, and duplicate gradient
  // ids make later copies reference the first (often `display:none`) one, so the gradient
  // never paints and the bolt looks missing.
  const uid = useId();

  return (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      fill={`url(#${uid}a)`}
      d="M5.363.902 1.284 7.667a.232.232 0 0 0 .2.351h2.063c.153 0 .278.125.278.279v4.319H3.58v1.17h.376a.135.135 0 0 0 .127-.067L8.62 6.286a.14.14 0 0 0-.119-.212H6.147a.232.232 0 0 1-.232-.232V.488a.138.138 0 0 0-.131-.14h-.42v.554Z"
    />
    <g filter={`url(#${uid}b)`}>
      <path
        fill={`url(#${uid}c)`}
        d="M5.247.416.875 7.666a.232.232 0 0 0 .199.352h2.063c.154 0 .279.125.279.279v5.35c0 .14.185.191.258.072L8.21 6.286a.14.14 0 0 0-.12-.212H5.738a.232.232 0 0 1-.232-.232V.488c0-.141-.185-.193-.258-.072Z"
      />
    </g>
    <path
      fill={`url(#${uid}d)`}
      d="M5.247.416.875 7.666a.232.232 0 0 0 .199.352h2.063c.154 0 .279.125.279.279v5.35c0 .14.185.191.258.072L8.21 6.286a.14.14 0 0 0-.12-.212H5.738a.232.232 0 0 1-.232-.232V.488c0-.141-.185-.193-.258-.072Z"
    />
    <path
      fill={`url(#${uid}e)`}
      d="M5.247.416.875 7.666a.232.232 0 0 0 .199.352h2.063c.154 0 .279.125.279.279v5.35c0 .14.185.191.258.072L8.21 6.286a.14.14 0 0 0-.12-.212H5.738a.232.232 0 0 1-.232-.232V.488c0-.141-.185-.193-.258-.072Z"
    />
    <path
      fill={`url(#${uid}f)`}
      d="M5.247.416.875 7.666a.232.232 0 0 0 .199.352h2.063c.154 0 .279.125.279.279v5.35c0 .14.185.191.258.072L8.21 6.286a.14.14 0 0 0-.12-.212H5.738a.232.232 0 0 1-.232-.232V.488c0-.141-.185-.193-.258-.072Z"
    />
    <path
      fill={`url(#${uid}g)`}
      d="M5.247.416.875 7.666a.232.232 0 0 0 .199.352h2.063c.154 0 .279.125.279.279v5.35c0 .14.185.191.258.072L8.21 6.286a.14.14 0 0 0-.12-.212H5.738a.232.232 0 0 1-.232-.232V.488c0-.141-.185-.193-.258-.072Z"
    />
    <defs>
      <linearGradient
        id={`${uid}a`}
        x1={6.204}
        x2={6.204}
        y1={2.983}
        y2={10.856}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFBD61" />
        <stop offset={1} stopColor="#EB5C74" />
      </linearGradient>
      <linearGradient
        id={`${uid}c`}
        x1={4.536}
        x2={4.536}
        y1={4.525}
        y2={12.293}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA547" />
        <stop offset={1} stopColor="#F14B49" />
      </linearGradient>
      <linearGradient
        id={`${uid}d`}
        x1={4.536}
        x2={4.536}
        y1={0.348}
        y2={5.881}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DF9844" />
        <stop offset={1} stopColor="#DF9844" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id={`${uid}f`}
        x1={3.532}
        x2={3.747}
        y1={3.186}
        y2={3.315}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C76C38" />
        <stop offset={1} stopColor="#C76C38" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id={`${uid}e`}
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 3.22798 -.70429 0 5.55 2.962)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE9052" />
        <stop offset={1} stopColor="#FE9052" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id={`${uid}g`}
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 3.34375 -1.21875 0 5.579 2.858)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB54B" />
        <stop offset={1} stopColor="#FFB54B" stopOpacity={0} />
      </radialGradient>
      <filter
        id={`${uid}b`}
        width={7.39}
        height={13.438}
        x={0.842}
        y={0.348}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.125} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.968627 0 0 0 0 0.431373 0 0 0 0 0.337255 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_29420_7824" />
      </filter>
    </defs>
  </svg>
  );
};

export default BoltIcon;
